import { useContext } from "react";
import SettingsContext from "../context/settings/SettingsContext";

const useSettings = () => useContext(SettingsContext);

export default useSettings;
